import React, { useState } from 'react';

export default function CondominioSelector({ condominios, onSelect, onCancel }) {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleSelect = () => {
    if (selectedIndex !== null) {
      onSelect(condominios[selectedIndex]);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden">
        <div className="bg-gradient-to-r from-primary-500 to-primary-600 p-6 text-white">
          <h2 className="text-2xl font-bold">Selecione o Condomínio</h2>
          <p className="text-primary-100 mt-1">
            Você tem acesso a {condominios.length} condomínio{condominios.length > 1 ? 's' : ''}
          </p>
        </div>

        <div className="p-6 overflow-y-auto max-h-[50vh]">
          <div className="space-y-3">
            {condominios.map((cond, index) => (
              <div
                key={index}
                onClick={() => setSelectedIndex(index)}
                className={`
                  p-4 rounded-xl border-2 cursor-pointer transition-all duration-200
                  ${
                    selectedIndex === index
                      ? 'border-primary-500 bg-primary-50 shadow-md transform scale-[1.02]'
                      : 'border-gray-200 hover:border-primary-300 hover:bg-gray-50'
                  }
                `}
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-800 text-lg">
                      {cond.nome || cond.condominio || 'Condomínio'}
                    </h3>
                    {cond.descricao && (
                      <p className="text-gray-600 text-sm mt-1">{cond.descricao}</p>
                    )}
                    {cond.endereco && (
                      <p className="text-gray-500 text-xs mt-1 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        {cond.endereco}
                      </p>
                    )}
                  </div>
                  
                  <div className={`
                    w-6 h-6 rounded-full border-2 flex items-center justify-center ml-4
                    ${selectedIndex === index ? 'border-primary-500' : 'border-gray-300'}
                  `}>
                    {selectedIndex === index && (
                      <div className="w-3 h-3 rounded-full bg-primary-500" />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-gray-200 p-6 bg-gray-50">
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onCancel}
              className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-100 transition-all duration-200"
            >
              Cancelar
            </button>
            <button
              onClick={handleSelect}
              disabled={selectedIndex === null}
              className={`
                flex-1 px-6 py-3 font-semibold rounded-xl transition-all duration-200
                ${
                  selectedIndex !== null
                    ? 'bg-gradient-to-r from-primary-500 to-primary-600 text-white hover:from-primary-600 hover:to-primary-700 shadow-lg transform hover:scale-[1.02]'
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }
              `}
            >
              <span className="flex items-center justify-center">
                Acessar Sistema
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}